module.exports = __webpack_public_path__ + "static/media/17-3.2f3e8897.mp3";